<template lang="html">
    <div id="account">
        <header>
            Password
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form" @submit.prevent="updatePassword">
            <div class="formGroup">
                <p class="help">For security verify your password:</p>
            </div>

            <div class="formGroup">
                <label>Current password</label>
                <password-input name="current_password" v-model="form.current_password" />
                <has-error :form="form" field="current_password"></has-error>
            </div>

            <div class="formGroup">
                <label>New password</label>
                <password-input v-model="form.new_password" name="new_password" />
                <has-error :form="form" field="new_password"></has-error>
            </div>

            <div class="form-group">
                <button
                    class="button"
                    data-cy="submitPassword"
                    :disabled="form.busy"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Update" }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { Form, HasError } from "vform";
import { ChevronLeftIcon } from "vue-feather-icons";
import PasswordInput from "@/components/App/password-input";
export default {
    name: "personal",
    components: { ChevronLeftIcon, HasError, PasswordInput },
    data() {
        return {
            form: new Form({
                current_password: "",
                new_password: "",
            }),
        };
    },
    methods: {
        updatePassword() {
            this.form.post("/update-password").then(() => {
                this.$notify({
                    duration: 1000,
                    text: "Your password has been updated",
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
